import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { useDialogState } from "../../../../../hooks/useDialogState";
import { useTreeState } from "../../../../../hooks/useTreeState";
import { useAttributeState } from "../../../../../hooks/useAttributeState";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import TextField from "@mui/material/TextField";
import ListItem from "@mui/material/ListItem";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Alert from "@mui/material/Alert";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";

import TreeComponentTypeService from "../../../../../services/TreeComponentTypeService";
import http from "../../../../../shared/http-common";

import {useStylesDialog} from "../../../../../shared/useStyleDialog";

// Fenster zum Anlegen eines Attributes

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="left" ref={ref} {...props} />;
});

const GetUnitList = async (token, realm) => {
    const formData = new FormData();
    formData.append("realm", realm);
    return await http.post(`/componentType/getComponentTypeAttributeUnitList`, formData, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

const GetDatatypeList = async (token, realm) => {
    const formData = new FormData();
    formData.append("realm", realm);
    return await http.post(`/componentType/getComponentTypeAttributeDatatypeList`, formData, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};


export default function CreateAttrDialog({reloadTreeItem}) {
    const classesDialog = useStylesDialog();
    const dialog = useDialogState();
    const tree = useTreeState();
    const attribute = useAttributeState();
    const token = useSelector((state) => state.keycloakToken);
    const realm = useSelector((state) => state.theRealm);
    const AttrDialogOpen = dialog.attrOpen;
    const setAttrDialogOpen = dialog.setAttrOpen;
    const TreeSelected = tree.selected;
    const setTreeSelected = tree.setSelected;
    const TreeSelectedItem = tree.selectedItem;
    const [AttrName, setAttrName] = useState("");
    const [AttrDataType, setAttrDataType] = useState("");
    const [AttrDesc, setAttrDesc] = useState("");
    const [AttrGlobalId, setAttrGlobalId] = useState("");
    const [AttrUnitId, setAttrUnitId] = useState("");
    const [AttrEnumerator, setAttrEnumerator] = useState([]);
    const [AttrConfirm, setAttrConfirm] = useState(false);
    const [unitList, setUnitList] = useState([]);
    const [datatypeList, setDatatypeList] = useState([]);
    const [enumEdit, setEnumEdit] = useState(false);

    useEffect(() => {
        async function fetchLists() {
            try {
                const [unitResult, datatypeResult] = await Promise.all([
                    GetUnitList(token, realm),
                    GetDatatypeList(token, realm),
                ]);
                setUnitList(unitResult.data);
                setDatatypeList(datatypeResult.data);
            } catch (e) {
                console.error(e);
            }
        }
        fetchLists();
    }, [token, realm]);

    const AddAttr = async () => {
        const newArray = {
            name: AttrName,
            globalId: AttrGlobalId,
            datatype: AttrDataType,
            unit: "",
            unitId: AttrUnitId,
            description: AttrDesc,
            enumerator: AttrEnumerator,
        };

        TreeSelectedItem.push(newArray);
        await Attr_Create();
    };

    const Attr_Create = async () => {
        try {
            const data = {
                name: TreeSelected.name.trim(),
                description: TreeSelected.description.trim(),
                cafmId: TreeSelected.cafm_id.trim(),
                globalId: TreeSelected.global_id.trim(),
                code: TreeSelected.code.trim(),
                parentComponent: TreeSelected.parent_objecttype_id,
                parentCafmId: TreeSelected.parent_cafm_id,
                parentGlobalId: TreeSelected.parent_global_id,
                attributes: TreeSelectedItem,
            };

            await TreeComponentTypeService.saveComponentType(token, realm, data);
            const result = await TreeComponentTypeService.getTreeData(token, realm);
            tree.setItems(result.data);

            const newItem = await reloadTreeItem();
            if (newItem instanceof Array && newItem.length > 0) {
                setTreeSelected(newItem[0]);
                if (newItem[0].attribute) {
                    const found = newItem[0].attribute.find((attr) => attr.name === AttrName);
                    if (found) attribute.setSelected(found);
                }
                attribute.setIsSelected(true);
            }
        } catch (e) {
            console.error(e);
        }
    };

    const handleEnumChange = (event) => {
        const enumArray = event.target.value.split(',');
        setAttrEnumerator(enumArray);
    };

    const handleEnumChange2 = (event, index) => {
        const enumString = event.target.value;
        if (index === AttrEnumerator?.length) {
            event.target.value = '';
        }
        const bums = [...(AttrEnumerator ?? [])];
        bums[index] = enumString;

        const newArray = [];
        bums.forEach(value => {
            if (value !== '') {
                newArray.push(value);
            }
        });
        setAttrEnumerator(newArray);
    };

    const handleUnitChange = (val) => {
        setAttrUnitId(val.toString());
    };

    const lastEnumIndex = AttrEnumerator?.length;

    return (
        <div>
            <Dialog
                className={classesDialog.dialog}
                open={AttrDialogOpen}
                onClose={() => setAttrDialogOpen(false)}
                TransitionComponent={Transition}
                fullScreen
            >
                <AppBar className={classesDialog.appBar}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={() => setAttrDialogOpen(false)}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" className={classesDialog.title}>
                            Merkmal hinzufügen
                        </Typography>
                        <Button
                            autoFocus
                            color="inherit"
                            onClick={() => {
                                setAttrConfirm(true);
                            }}
                        >
                            Bestätigen
                        </Button>
                    </Toolbar>
                </AppBar>
                <List>
                    <ListItem>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="Attr_name"
                            label="Name"
                            type="text"
                            fullWidth
                            onChange={(e) => setAttrName(e.target.value)}
                        />
                    </ListItem>
                    <ListItem>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="Attr_globalid"
                            label="GUID"
                            type="text"
                            fullWidth
                            onChange={(e) => setAttrGlobalId(e.target.value)}
                        />
                    </ListItem>
                    <ListItem>
                        <FormControl className={classesDialog.formControl}>
                            <InputLabel id="Attr_type_title">Daten-Typ</InputLabel>
                            <Select
                                labelId="Attr_type_title"
                                value={AttrDataType}
                                id="Attr_datatype"
                                required
                                fullWidth
                                onChange={(e) => setAttrDataType(e.target.value)}
                            >
                                <MenuItem value=""></MenuItem>
                                {datatypeList.map((item) => (
                                    <MenuItem key={item} value={item}>{item}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </ListItem>
                    <ListItem>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="Attr_description"
                            label="Hinweis"
                            type="text"
                            fullWidth
                            onChange={(e) => setAttrDesc(e.target.value)}
                        />
                    </ListItem>
                    <ListItem>
                        <FormControl className={classesDialog.formControl}>
                            <InputLabel id="Attr_unit_title">Unit</InputLabel>
                            <Select
                                labelId="Attr_unit_title"
                                value={AttrUnitId}
                                id="Attr_unit"
                                onChange={(e) => handleUnitChange(e.target.value)}
                            >
                                <MenuItem value=""></MenuItem>
                                {unitList.map((item) => (
                                    <MenuItem key={item.code} value={item.code}>{item.name} [{item.code}]</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </ListItem>
                    <ListItem>
                        <Button onClick={() => setEnumEdit(true)}>Enumerator-Werte eingeben</Button>
                    </ListItem>
                    <ListItem>
                        <TextField
                            margin="dense"
                            id="Attr_enums"
                            type="text"
                            fullWidth
                            onChange={(e) => handleEnumChange(e)}
                            value={AttrEnumerator}
                            disabled
                            defaultValue={AttrEnumerator}
                        />
                    </ListItem>
                    <Divider />
                </List>
            </Dialog>
            {AttrName !== "" ?
                <Dialog
                    className={classesDialog.dialogConfirm}
                    open={AttrConfirm}
                    onClose={() => setAttrConfirm(false)}
                    TransitionComponent={Transition}
                >
                    <AppBar className={classesDialog.appBar}>
                        <Toolbar>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={() => setAttrConfirm(false)}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" className={classesDialog.title}>
                                Merkmal <b>{AttrName}</b> anlegen
                            </Typography>
                        </Toolbar>
                    </AppBar>
                    <DialogContent>
                        <Alert variant="outlined" severity="success">
                            Das Merkmal {AttrName} kann angelegt werden! Das zugehörige Bauteil ist {TreeSelected.name}.
                        </Alert>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                setAttrConfirm(false);
                            }}
                            color="primary"
                        >
                            Abbrechen
                        </Button>
                        <Button
                            onClick={async () => {
                                await AddAttr();
                                setAttrDialogOpen(false);
                                setAttrConfirm(false);
                            }}
                            color="primary"
                        >
                            Bestätigen
                        </Button>
                    </DialogActions>
                </Dialog>
                :
                <Dialog
                    className={classesDialog.dialogConfirm}
                    open={AttrConfirm}
                    onClose={() => setAttrConfirm(false)}
                    TransitionComponent={Transition}
                >
                    <AppBar className={classesDialog.appBar}>
                        <Toolbar>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={() => setAttrConfirm(false)}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" className={classesDialog.title}>
                                Merkmal <b>{AttrName}</b> anlegen
                            </Typography>
                        </Toolbar>
                    </AppBar>
                    <DialogContent>
                        <Alert variant="outlined" severity="warning">
                            Keinen Namen vergeben!
                        </Alert>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                setAttrConfirm(false);
                            }}
                            color="primary"
                        >
                            Eingaben ändern
                        </Button>
                    </DialogActions>
                </Dialog>
            }
            <Dialog
                className={classesDialog.dialogConfirm}
                open={enumEdit}
                onClose={() => setEnumEdit(false)}
                TransitionComponent={Transition}
            >
                <AppBar className={classesDialog.appBar}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={() => setEnumEdit(false)}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" className={classesDialog.title}>
                            Enumerator bearbeiten für <b>{AttrName}</b>
                        </Typography>
                    </Toolbar>
                </AppBar>
                <DialogContent>
                    <div>
                        {AttrEnumerator?.map((item, index) => (
                            <TextField
                                key={index}
                                autoFocus
                                defaultValue={item}
                                margin="dense"
                                id={`enum_${index}`}
                                label={`Enum-Wert ${index + 1}`}
                                type="text"
                                fullWidth
                                onChange={(e) => handleEnumChange2(e, index)}
                            />
                        ))}
                        <TextField
                            autoFocus
                            defaultValue=""
                            margin="dense"
                            id={`enum_${lastEnumIndex}`}
                            label={`Enum-Wert neu`}
                            type="text"
                            fullWidth
                            onChange={(e) => handleEnumChange2(e, lastEnumIndex)}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            setEnumEdit(false);
                        }}
                        color="primary"
                    >
                        Abbrechen
                    </Button>
                    <Button
                        onClick={() => {
                            setEnumEdit(false);
                        }}
                        color="primary"
                    >
                        Bestätigen
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
